module.exports = __webpack_public_path__ + "img/moscow-mule.00a44ea4.jpg";